import React from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { jwtDecode } from 'jwt-decode';
import BASE_URL from '../config/config';
import { claves } from '../queries/cliente';
import { FiCheckCircle, FiAlertTriangle, FiClock } from 'react-icons/fi';
import { cerrarSesion } from '../auth/sesion';

const Verificacion = () => {
  const { t } = useTranslation();

  const token = localStorage.getItem("AuthToken");
  let tokenInfo = {};

  if (token) {
    tokenInfo = jwtDecode(token);
  }

  const handleLogout = () => {
    cerrarSesion({ caducada: false });
  };

  // Se sondea el estado de la cuenta cada 5s: en cuanto un técnico la verifica,
  // la pantalla cambia sola sin recargar.
  const consultaEstado = useQuery({
    queryKey: claves.estadoCuenta(tokenInfo.usuario),
    queryFn: async () => (await axios.get(`${BASE_URL}/usuario/estado/${tokenInfo.usuario}`)).data.estado,
    enabled: Boolean(tokenInfo.usuario),
    refetchInterval: 5000,
  });

  const estado = !token || consultaEstado.isError
    ? 'error'
    : (consultaEstado.data === 'verificado' ? 'verificado' : 'pendiente');

  return (
    <main className='verificando'>
      <div className="bg-intro-blob bg-intro-blob-1"></div>
      <div className="verificar-card">
        {estado === 'verificado' ? (
          <>
            <div className="verificar-icon verificar-icon-exito"><FiCheckCircle /></div>
            <h2>{t('estados.cuentaVerificadaTitulo')}</h2>
            <p>{t('estados.cuentaVerificadaTexto')}</p>
            <button className='terminar-verificacion' onClick={handleLogout}>
              {t('estados.terminarVerificacion')}
            </button>
          </>
        ) : estado === 'error' ? (
          <>
            <div className="verificar-icon verificar-icon-error"><FiAlertTriangle /></div>
            <h2>{t('estados.errorVerificacionTitulo')}</h2>
            <p>{t('estados.errorVerificacionTexto')}</p>
          </>
        ) : (
          <>
            <div className="verificar-icon verificar-icon-pendiente"><FiClock /></div>
            <h2>{t('estados.verificacionPendienteTitulo')}</h2>
            <p>{t('estados.verificacionPendienteTexto')}</p>
          </>
        )}
      </div>
    </main>
  );
}

export default Verificacion;
